import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';
import React from 'react';
import { useMediaBreakpoints } from 'shared/media';


interface Props {
  icon: IconDefinition
  title: string
  children: React.ReactNode
  className?: string
}



export const BankStatementsFeature = (props: Props) => {
  const { mdGTE } = useMediaBreakpoints(); 
  if (mdGTE)
    return <BankStatementsFeatureStacked {...props}/>;
  return <BankStatementsFeatureHorizontal {...props}/>;
};


const BankStatementsFeatureStacked = (props: Props) => (
  <div className={cs("text-center", props.className)}>
    <div className="py-3"><FontAwesomeIcon icon={props.icon} size="4x"/></div>
    <h5 className="m-0">{props.title}</h5>
    <div className="py-3">
      {props.children}
    </div>
  </div>
);

const BankStatementsFeatureHorizontal = (props: Props) => (
  <div className={cs("d-flex py-3", props.className)}>
    <div style={{width: '80px', minWidth: '80px'}}>
      <FontAwesomeIcon icon={props.icon} size="3x"/>
    </div>
    <div>
      <b>{props.title}</b>
      <br/>
      {props.children}
    </div>
  </div>
);
